import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { StaticCalendar } from './staticCalendar';
import {StaticCalendarRoutingModule} from "./staticCalendar-routing.module";
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import {TableModule} from "../generic/table/table.module";
import {AchievementService} from "../../../service/AchievementService";
import {DlDateTimePickerModule} from "angular-bootstrap-datetimepicker";
import {NgSelectModule} from "@ng-select/ng-select";
import {NgCalendarModule} from "ionic2-calendar";
import {NgToggleModule} from "ng-toggle-button";
import {DndModule} from "ngx-drag-drop";

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    StaticCalendarRoutingModule,
    NgxDatatableModule,
    TableModule,
    DlDateTimePickerModule,
    NgSelectModule,
    NgCalendarModule,
    NgToggleModule,
    DndModule
  ],
  providers: [AchievementService],
  exports: [
    StaticCalendar
  ],
  declarations: [StaticCalendar]
})
export class StaticCalendarModule {}
